module.exports = __webpack_public_path__ + "static/media/Showcase_10.a21778c1.jpg";